import {configureStore} from "@reduxjs/toolkit";
import postReducer from '../redux/post'
import globalReducer from '../redux/global'
import homeReducer from'../redux/home'
import aboutReducer from '../redux/about'
import storyReducer from '../redux/story'
import managementReducer from '../redux/management'
import missionReducer from '../redux/mission'
import directorReducer from '../redux/directors'
import projectReducer from '../redux/project'
import newsReducer from '../redux/news'
import businessReducer from '../redux/business'
import landownerReducer from '../redux/landowner'
import buyerReducer from '../redux/buyer'
import customerReducer from '../redux/customer'
import careerReducer from '../redux/career'
import contactReducer from '../redux/contact'
import loaderReducer from '../redux/loader'
import rootReducer from '../redux/root'
import formReducer from '../redux/form'
import socialReducer from '../redux/social'
import subscriptionReducer from '../redux/subscription'

const store = configureStore({
    reducer: {
        post: postReducer,
        globalReducer,
        home : homeReducer,
        about: aboutReducer,
        story: storyReducer,
        mission: missionReducer,
        management: managementReducer,
        director: directorReducer,
        project: projectReducer,
        news: newsReducer,
        business: businessReducer,
        landowner: landownerReducer,
        form : formReducer,
        buyer : buyerReducer,
        customer : customerReducer,
        career: careerReducer,
        contact : contactReducer,
        social: socialReducer,
        subscription : subscriptionReducer,
        loaderReducer,
        rootReducer

    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})

export default store

